import type { MutationTree } from 'vuex'
import type { SettingState } from './types'
import { GET_ALL_SETTINGS, CREATE_OR_UPDATE_SETTING } from './types'

export const mutations: MutationTree<SettingState> = {
  [GET_ALL_SETTINGS](state: SettingState, settings: SettingModel[]) {
    state.settings = settings
  },
  [CREATE_OR_UPDATE_SETTING](state: SettingState, settings: SettingModel[]) {
    const transform = settings.reduce((carry: SettingModel[], item: SettingModel) => {
      const foundIndex = carry.findIndex((e) => e.key === item.key)
      if (foundIndex !== -1) {
        carry.splice(foundIndex, 1)
        carry.push(item)
        return carry
      }
      carry.push(item)
      return carry
    }, state.settings)
    state.settings = transform
  },
}
